/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API48546Item {
  
  /** 项目编号 */
  projectNo?: string;
  
  /** 汇报编号 */
  reportNo?: string;
  
  /** 汇报日期 */
  reportDate?: any;
  
  /** 阅读状态1未读2已读 */
  readStatus?: number;
  
  /** 创建者 */
  creator?: string;
  
  /** 创建者名称 */
  creatorName?: string;
  
  /** 健康标志：0-10 */
  healthFlag?: number;
  
  /** 项目进度（61.23%存6123） */
  projectProgress?: number;
  
  /** 项目进度,double值，61.23 */
  projectProgressDou?: any;
  
  /** 项目进度，描述值：61.23% */
  projectProgressDesc?: string;
  
  /** 是否可查看 */
  read?: boolean;
  
  /** 是否可编辑 */
  edit?: boolean;
  
  /** 是否可删除 */
  delete?: boolean;
  
  /** 是否可下载 */
  download?: boolean;
  
};
    
  



export interface API48546Req {
  
  /** 项目编号 */
  projectNo?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API48546Res {
  /** T  */
  list?: API48546Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 48546 项目汇报列表

export interface IUseGetAPI48546Return {
  /** 项目汇报列表: 接口请求状态 */
  isAPI48546Loading: boolean;
  /** 项目汇报列表: 接口请求返回数据 */
  dataAPI48546: API48546Res;
  /**  项目汇报列表: 接口数据请求方法 */
  fetchAPI48546Data:  (inputs: API48546Req, config?: YWRequestConfig) => Promise<API48546Res>;
  /** 项目汇报列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48546 = ():IUseGetAPI48546Return => {
  let isMount = true;
  const [isAPI48546Loading, setIsAPI48546Loading] = useState(false);
  const [dataAPI48546, setDataAPI48546] = useState<API48546Res>({} as API48546Res);
  const requestUrl = `${basePath}/corp-admin/project/report/page`;

  const fetchAPI48546Data = async (inputs: API48546Req, config?: YWRequestConfig): Promise<API48546Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48546Req>) || {}) as API48546Req;
    
  
    if ( isMount ) {
      setIsAPI48546Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48546Res>(`${basePath}/corp-admin/project/report/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48546(res || {} as API48546Res);
        setIsAPI48546Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48546Loading(false);
      }
      return false as unknown as API48546Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48546Loading,
    dataAPI48546,
    fetchAPI48546Data,
    requestUrl,
  }
}

